import en from "./en.js";
import id from "./id.js";
import ru from "./ru.js";
import he from "./he.js";
import pl from "./pl.js";
import fi from "./fi.js";
import es from "./es.js";
import TimeAgo from "../../_snowpack/pkg/javascript-time-ago.js";
export const languages = [en, id, ru, he, pl, fi, es];
export const languageNames = languages.map((language) => language.anime_airing.locale.locale);
for (const language of languages) {
  TimeAgo.addLocale(language.anime_airing.locale);
}
TimeAgo.setDefaultLocale(en.anime_airing.locale.locale);
function localizeTo(language, reference, fallbackReference) {
  return language.strings[reference] || language.strings[fallbackReference] || `untranslated ${reference} for language ${language.locale.locale}`;
}
export function createLocalization(lang_locale = "en", context = "anime_airing") {
  const language = languages.find((lang) => lang[context].locale.locale === lang_locale)[context];
  const timeAgo = new TimeAgo(language.locale.locale);
  return {
    localize: (reference, fallbackReference) => localizeTo(language, reference, fallbackReference),
    timeAgo
  };
}
//# sourceMappingURL=index.js.map
